import * as React from 'react'
import { Helmet } from "react-helmet";
import generateStructuredFaqs from "../../services/generateStructuredFaqs";

type SeoProps = {
    title: string,
    description: string,
    switchTitleOrder?: boolean,
    path: string,
    faqs?: { question: string, answer: string }[]
}

export const Seo = ({ title, description, switchTitleOrder, path, faqs }: SeoProps) => {
    if (!path) return null;
    path = path.endsWith('/') ? path : `${path}/`;
    const url = `https://www.sunheron.com`;
    const completeUrl = `${url}${path}`;
    const titleText = switchTitleOrder ? `Sunheron | ${title}` : `${title} | Sunheron`;

    return (
        <Helmet>
            <html lang="en" />
            <link
                rel="shortcut icon"
                href="/favicon.ico"
                type="image/x-icon"
            />
            <title>{titleText}</title>
            <meta name="title" content={`${titleText}`} />
            <meta name="description" content={description} />
            <meta name="keywords" content="weather, tourism, season, temperature, sea temperature, wet day, climate, precipitation, rain season, rain, sunhours, wind, humidity" />
            <meta name="robots" content="index, follow" />
            <meta name="language" content="en" />
            <meta name="revisit-after" content="30 days" />
            <meta name="google-site-verification" content="2kiGFT2MiCnfz2Xi33lKz14y67PWEp-Boh8Fz25VK40" />
            <link rel="apple-touch-icon" sizes="57x57" href="https://www.sunheron.com/sunheron-touch-icon-57x57.png" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={completeUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={`${url}/sunheron-og.png`} />
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={completeUrl} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={`${url}/sunheron-og.png`} />
            {faqs && <script type="application/ld+json">{generateStructuredFaqs(faqs)}</script>}
        </Helmet>
    )
}